import { designToken, quickProperty } from '../component-tokens';
export const emptyStateData = {
    name: 'empty-state',
    tag: 'chameleon-empty-state',
    reactImports: 'EmptyState',
    attributes: {
        'align-items': quickProperty('center'),
        padding: designToken('spacing-06'),
        display: quickProperty('flex'),
        'flex-direction': quickProperty('column'),
        gap: designToken('spacing-02'),
        margin: quickProperty('auto'),
        'max-width': quickProperty('25.3125rem'),
    },
    sizes: [
        {
            name: 'small',
            attributes: {
                padding: designToken('spacing-04'),
                'max-width': quickProperty('14rem'),
            },
            children: [
                {
                    name: 'icon',
                    attributes: {
                        '--goto-icon-size': quickProperty('2.5rem'),
                    },
                },
                {
                    name: 'description',
                    attributes: {
                        font: designToken('caption-medium'),
                    },
                },
            ],
        },
        {
            name: 'large',
            attributes: {
                padding: designToken('spacing-09'),
                gap: designToken('spacing-04'),
                'max-width': quickProperty('34.6875rem'),
            },
            children: [
                {
                    name: 'title',
                    attributes: {
                        font: designToken('heading-large'),
                        'text-align': quickProperty('center'),
                    },
                },
                {
                    name: 'description',
                    attributes: {
                        font: designToken('body-large'),
                    },
                },
            ],
        },
    ],
    children: [
        {
            name: 'icon',
            attributes: {
                '--goto-icon-color': designToken('empty-state-icon-color'),
                '--goto-icon-size': quickProperty('4rem'),
            },
        },
        {
            name: 'title',
            attributes: {
                font: designToken('heading-small'),
                color: designToken('type-color-default'),
                margin: quickProperty('0'),
                'text-align': quickProperty('center'),
            },
        },
        {
            name: 'description',
            attributes: {
                font: designToken('body-small'),
                color: designToken('type-color-secondary'),
                'text-align': quickProperty('center'),
            },
        },
        {
            name: 'actions',
            attributes: {
                'align-items': quickProperty('center'),
                display: quickProperty('flex'),
                'flex-direction': quickProperty('column'),
                gap: designToken('spacing-04'),
                'padding-top': designToken('spacing-04'),
            },
        },
    ],
};
